import {
  PropsWithChildren,
  createContext,
  useCallback,
  useEffect,
  useState,
} from "react";

import { fetcher } from "./fetcher";

export const APIContext = createContext<{
  domain: string;
  getAccessToken: () => Promise<string>;
  latestToken?: string;
}>({ domain: "", getAccessToken: () => Promise.resolve("") });

interface Props extends PropsWithChildren {
  domain: string;
  getAccessToken: () => Promise<string>;
  fallback?: React.ReactNode;
}

export function APIProvider(props: Props) {
  const { domain, children } = props;

  const [initialized, setInitialized] = useState(false);

  const [latestToken, setLatestToken] = useState<string | undefined>(undefined);

  const getAccessToken = useCallback(async () => {
    const token = await props.getAccessToken();
    setLatestToken(token);
    return token;
  }, [props.getAccessToken, setLatestToken]);

  useEffect(() => {
    fetcher.initialize({
      domain,
      getAccessToken,
    });
    setInitialized(true);
  }, [domain, getAccessToken]);

  if (!initialized) {
    return <>{props.fallback}</>;
  }

  return (
    <APIContext.Provider value={{ domain, getAccessToken, latestToken }}>
      {children}
    </APIContext.Provider>
  );
}
